import { Component, OnDestroy, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { Observable } from "rxjs/Observable";

import { Country } from "../../../../../views/shared/models/country";
import {
  OrgModel,
  TranferStudentService
} from "../../../accomsupport/service/transfer-student.service";
import { CommonService } from "../../../../../views/services/common.service";
import { AppService } from "../../../../../views/services/app.service";
import { User } from "../../../../../views/services/user.model";
import { ExamineeInternalRequestService } from "../../../accomsupport/service/examinee-request.service";
import { AccomSupportService } from "../../services/accomsupport.service";

@Component({
  selector: "app-transferstudent",
  templateUrl: "./transferstudent.component.html",
  styleUrls: ["./transferstudent.component.css"]
})
export class TransferStudentCommonComponent implements OnInit, OnDestroy {
  public infoMsg: string;
  public countriesList: Country[];
  public userProfile: User;
  public oldOrg: any = {};
  public fetchedOrg: any = {};
  public transferStudentForm: FormGroup;
  public transferStudentFormSubmitVal: boolean = false;
  public mdmFormSubmitVal: boolean = false;
  public showCountrySearchDiv = false;
  public showMdmSearchDiv = false;
  public displayMdmError = false;
  public basicOrgVal = false;
  public studentDetails: any;
  public searchFields: any = {};
  public selectedCountry: string = "";
  public stateList: any = [];
  public cityList: any = [];
  public orgList: any = [];
  public orgModel: OrgModel;
  public displayOrgIdError: string = "";
  public displayMdmIdError: string = "";
  public basicOrg: string = "";
  public mdmId: string = "";

  constructor(
    private appService: AppService,
    private examineeRequestService: ExamineeInternalRequestService,
    public router: Router,
    public accomSupportService: AccomSupportService,
    public tranferStudentService: TranferStudentService,
    public commonService: CommonService
  ) {}

  ngOnInit() {
    this.appService.getUserProfile().then(user => (this.userProfile = user));
    if (sessionStorage.getItem("internalStudentDetails")) {
      this.studentDetails = JSON.parse(
        sessionStorage.getItem("internalStudentDetails")
      );
    }
    if (this.studentDetails) {
      Observable.forkJoin(
        this.examineeRequestService.getCountries(),
        this.tranferStudentService.getRequestDetails(
          this.studentDetails.requestId
        )
      ).subscribe(([data, oldOrg]) => {
        this.countriesList = data;
        this.oldOrg = oldOrg[0];
      });
    }

    this.transferStudentForm = new FormGroup({
      country: new FormControl("", Validators.required),
      state: new FormControl(""),
      city: new FormControl("", Validators.required),
      newOrganization: new FormControl("", Validators.required)
    });
  }
  changeCountry(event) {
    this.transferStudentFormSubmitVal = false;
    this.displayOrgIdError = "";
    this.searchFields = {};
    this.cityList = [];
    this.stateList = [];
    this.orgList = [];
    this.selectedCountry = this.transferStudentForm.controls["country"].value
      ? this.transferStudentForm.controls["country"].value.id
      : null;
    if (this.selectedCountry && this.selectedCountry === "US") {
      this.searchFields.countryId = this.selectedCountry;
      this.transferStudentForm.controls["state"].setValidators(
        Validators.required
      );
      Observable.forkJoin(
        this.tranferStudentService.getUsStateList()
      ).subscribe(([result]) => {
        this.stateList = result.body;
        this.stateList.sort((a, b) => (a.name > b.name ? 1 : -1));
      });
    } else if (this.selectedCountry) {
      this.transferStudentForm.controls["state"].clearValidators();
      this.searchFields.countryId = this.selectedCountry;
      Observable.forkJoin(
        this.tranferStudentService.getOrganizationlist(this.searchFields)
      ).subscribe(([result]) => {
        this.cityList = this.removeDuplicates(result.body);
        this.cityList.sort((a, b) => (a.city > b.city ? 1 : -1));
      });
    }
  }

  removeDuplicates(originalArray) {
    const newArray = [];
    const lookupObject = {};

    if (originalArray) {
      for (const i in originalArray) {
        if (originalArray[i]) {
          lookupObject[originalArray[i]["city"]] = originalArray[i];
        }
      }
    }
    if (lookupObject) {
      for (const i in lookupObject) {
        if (lookupObject[i]) {
          newArray.push(lookupObject[i]);
        }
      }
    }
    return newArray;
  }
  changeState(event) {
    this.transferStudentFormSubmitVal = false;
    this.displayOrgIdError = "";
    this.cityList = [];
    this.orgList = [];
    this.searchFields.city = "";
    this.searchFields.newOrganization = "";
    this.searchFields.stateId = this.transferStudentForm.controls["state"].value
      ? this.transferStudentForm.controls["state"].value.code
      : null;
    if (this.searchFields.stateId) {
      Observable.forkJoin(
        this.tranferStudentService.getUsCityList(this.searchFields.stateId)
      ).subscribe(([result]) => {
        this.cityList = result.body;
        this.cityList.sort((a, b) => (a.city > b.city ? 1 : -1));
      });
    }
  }
  changeCity(event) {
    this.transferStudentFormSubmitVal = false;
    this.displayOrgIdError = "";
    this.orgList = [];
    this.searchFields.newOrganization = "";
    this.searchFields.cityId = this.transferStudentForm.controls["city"].value
      ? this.transferStudentForm.controls["city"].value.city
      : null;
    if (this.searchFields.cityId) {
      Observable.forkJoin(
        this.tranferStudentService.getOrganizationlist(this.searchFields)
      ).subscribe(([result]) => {
        this.orgList = result.body;
        this.orgList.sort((a, b) =>
          a.organizationName > b.organizationName ? 1 : -1
        );
        this.orgList.forEach(element => {
          if (element.organizationName) {
            element.newOrganization = element.organizationName;
            element.displayOrgName = element.organizationName;
          }
          if (element.addrLine1) {
            element.displayOrgName += "," + element.addrLine1;
          }
          if (element.addrLine2) {
            element.displayOrgName += "," + element.addrLine2;
          }
          if (element.addrLine3) {
            element.displayOrgName += "," + element.addrLine3;
          }
          if (element.addrLine4) {
            element.displayOrgName += "," + element.addrLine4;
          }

          if (element.city) {
            element.newOrganization += ", " + element.city;
            element.displayOrgName += "," + element.city;
          }
          if (element.stateProvince) {
            if (this.selectedCountry === "US") {
              element.newOrganization += ", " + element.stateProvince;
            }
            element.displayOrgName += "," + element.stateProvince;
          }
          if (this.selectedCountry !== "US") {
            element.newOrganization += ", " + this.selectedCountry;
            element.displayOrgName += "," + this.selectedCountry;
          }
        });
      });
    }
  }
  changeOrg(event) {
    this.transferStudentFormSubmitVal = false;
    this.displayOrgIdError = "";
    this.searchFields.newOrganizationName = this.transferStudentForm.controls[
      "newOrganization"
    ].value
      ? this.transferStudentForm.controls["newOrganization"].value
          .newOrganization
      : null;
  }
  transferStudentFormSubmit(formVal) {
    this.transferStudentFormSubmitVal = true;
    if (
      this.selectedCountry === "US" &&
      (formVal.value.country !== "" ||
        formVal.value.state !== "" ||
        formVal.value.city !== "" ||
        formVal.value.newOrganization !== "") &&
      formVal.valid
    ) {
      this.transferingStudent(formVal);
    } else if (
      (formVal.value.country !== "" ||
        formVal.value.city !== "" ||
        formVal.value.newOrganization !== "") &&
      formVal.valid
    ) {
      this.transferingStudent(formVal);
    }
  }

  /**
   * Display respective form/fieldset based on radio option.
   * @param opt
   */
  public searchOption(opt) {
    this.displayMdmIdError = "";
    this.displayOrgIdError = "";
    if (opt === "Yes") {
      this.searchFields.newOrganization = "";
      this.showCountrySearchDiv = true;
      this.showMdmSearchDiv = false;
      this.displayMdmError = false;
    } else {
      this.searchFields.newOrganization = "";
      this.showCountrySearchDiv = false;
      this.displayMdmError = false;
      this.showMdmSearchDiv = true;
    }
  }
  getByMdmId() {
    if (this.mdmId) {
      Observable.forkJoin(
        this.tranferStudentService.getOrgByMdmId(this.mdmId)
      ).subscribe(([result]) => {
        console.log(result.body);
        this.fetchedOrg = result.body;
        if (this.fetchedOrg.organizationName) {
          this.displayMdmError = false;
          if (this.fetchedOrg.organizationName) {
            this.searchFields.newOrganizationName = this.fetchedOrg.organizationName;
            this.basicOrg = this.fetchedOrg.organizationName;
            this.searchFields.newOrganizationId = this.fetchedOrg.partyId;
            this.searchFields.newOrgMdmId = this.mdmId;
            this.searchFields.HS_CODE = this.fetchedOrg.hsCode;
          }
          if (this.fetchedOrg.addrLine1) {
            this.basicOrg += "," + this.fetchedOrg.addrLine1;
          }
          if (this.fetchedOrg.addrLine2) {
            this.basicOrg += "," + this.fetchedOrg.addrLine2;
          }
          if (this.fetchedOrg.addrLine3) {
            this.basicOrg += "," + this.fetchedOrg.addrLine3;
          }
          if (this.fetchedOrg.addrLine4) {
            this.basicOrg += "," + this.fetchedOrg.addrLine4;
          }
          if (this.fetchedOrg.city) {
            this.searchFields.newOrganizationName +=
              ", " + this.fetchedOrg.city;
            this.basicOrg += "," + this.fetchedOrg.city;
          }
          if (this.fetchedOrg.stateProvince) {
            if (this.fetchedOrg.country === "US") {
              this.searchFields.newOrganizationName +=
                ", " + this.fetchedOrg.stateProvince;
            }
            this.basicOrg += "," + this.fetchedOrg.stateProvince;
          }
          if (this.fetchedOrg.country !== "US") {
            this.searchFields.newOrganizationName +=
              ", " + this.fetchedOrg.country;
            this.basicOrg += "," + this.fetchedOrg.country;
          }
          this.basicOrgVal = true;
        } else {
          this.displayMdmIdError =
            "Unable to transfer student to this organization. No active organization record exist.";
          this.basicOrgVal = false;
          this.displayMdmError = true;
        }
      });
    }
  }

  /**
   *Submit form details
   */
  mdmSearchFormSubmit() {
    this.mdmFormSubmitVal = true;
    console.log("Submit transfer by mdm_id");
    this.transferStudent();
  }

  transferStudent() {
    this.searchFields.REQUEST_ID = this.studentDetails.requestId;
    this.searchFields.PERSON_ID = this.studentDetails.personId;
    this.searchFields.UPDATED_BY_DS = this.userProfile.loggedInUser;
    this.tranferStudentService
      .updateNewOrg(this.searchFields)
      .subscribe(res => {
        if (res) {
          const value: any = {};
          value.personId = this.studentDetails.personId;
          value.studentFirstName = this.studentDetails.firstNm;
          value.studentLastName = this.studentDetails.lastNm;
          value.oldOrganizationId = this.oldOrg.ORGANIZATION_ID;
          value.oldOrganizationName = this.oldOrg.ORGANIZATION_NM;
          value.oldOrgMdmId = this.oldOrg.ORG_MDM_ID;
          value.newOrgMdmId = this.searchFields.newOrgMdmId;
          value.newOrganizationId = this.searchFields.newOrganizationId;
          value.newOrganizationName = this.searchFields.newOrganizationName;

          this.tranferStudentService.addAuditLog(value).subscribe(ans => {
            if (this.userProfile.role === "ACCSUPPORT") {
              console.log("ACCSUPPORT role routing");
              this.router.navigate(["/exAccreqdetails"]);
            } else {
              console.log("ACCMGR role routing");
              this.router.navigate(["/exreqdetails"]);
            }
          });
        }
      });
  }

  transferingStudent(formVal: any) {
    this.searchFields.REQUEST_ID = this.studentDetails.requestId;
    this.searchFields.PERSON_ID = this.studentDetails.personId;
    this.searchFields.UPDATED_BY_DS = this.userProfile.loggedInUser;
    this.searchFields.newOrgMdmId = formVal.value.newOrganization.mdmId;
    this.searchFields.HS_CODE = formVal.value.newOrganization.keyValue;
    this.tranferStudentService
      .getOrgId(this.searchFields.newOrgMdmId)
      .subscribe(data => {
        if (data) {
          let negativeData: Array<any> = [];
          this.orgModel = data.body;
          if (this.orgModel.data != null) {
            negativeData = this.orgModel.data.filter(function(item) {
              return item.keyType === "PARTY ID" && item.statusCode === "A";
            });
          }
          if (negativeData.length === 1) {
            this.searchFields.newOrganizationId = negativeData.length
              ? negativeData[0].keyValue
              : "";
            this.tranferStudentService
              .updateNewOrg(this.searchFields)
              .subscribe(res => {
                if (res) {
                  const value: any = {};
                  value.personId = this.studentDetails.personId;
                  value.studentFirstName = this.studentDetails.firstNm;
                  value.studentLastName = this.studentDetails.lastNm;
                  value.oldOrganizationId = this.oldOrg.ORGANIZATION_ID;
                  value.oldOrganizationName = this.oldOrg.ORGANIZATION_NM;
                  value.oldOrgMdmId = this.oldOrg.ORG_MDM_ID;
                  value.newOrgMdmId = this.searchFields.newOrgMdmId;
                  value.newOrganizationId = this.searchFields.newOrganizationId;
                  value.newOrganizationName = this.searchFields.newOrganizationName;

                  this.tranferStudentService
                    .addAuditLog(value)
                    .subscribe(ans => {
                      if (this.userProfile.role === "ACCSUPPORT") {
                        console.log("ACCSUPPORT role routing");
                        this.router.navigate(["/exAccreqdetails"]);
                      } else {
                        console.log("ACCMGR role routing");
                        this.router.navigate(["/exreqdetails"]);
                      }
                    });
                }
              });
          } else if (negativeData.length > 1) {
            this.displayOrgIdError =
              "Unable to transfer student to this organization. Multiple active organization references exist for this record. (Error: MDM_ID:" +
              this.searchFields.newOrgMdmId +
              ")";
          } else {
            this.displayOrgIdError =
              "Unable to transfer student to this organization. No active organization record exist. (Error: MDM_ID:" +
              this.searchFields.newOrgMdmId +
              ")";
          }
        }
      });
  }

  ngOnDestroy() {}
}



// WEBPACK FOOTER //
// ./client/app/internal/common/components/transferstudent/transferstudent.component.ts